/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';

// Two types classroom view or webinar view, changes background and chat component
export default class SessionItemView3 extends Component {
  render() {
    const { url } = this.props.match;
    console.log(url);
    return (
      <div className="sessionItemView">

        <div className="gradient" />
        <div className="bg" />

        <div className="sessionItemHolder">

          <div className="video">
            {url === '/main/breakout-sessions/class/30 minutes' &&
              <video
                src="https://front.travpromobile.com/614/TravPRO TRAINING [Advisors].mp4"
                autoPlay
                preload="auto"
                height="100%"
                width="100%"
                controls
              >
                <track kind="captions" />
              </video>
            }
            {url === '/main/breakout-sessions/class/23 minutes' &&
            <video
              src="https://front.travpromobile.com/614/bigmarker-recording.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
          }
            {url === '/main/breakout-sessions/class/25 minutes' &&
            <video
              src="https://front.travpromobile.com/614/zoom_0.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
        }
            <div className="title">
              <span>Europe Travel</span>
              <div className="subtitle">
              The European Commission unveiled a series of measures aimed at ensuring people can start travelling safely across the continent again as governments try to revive tourism and airline industries brought to a halt by the coronavirus.
              </div>
            </div>
          </div>

          <div className="speakerHolder">
            <img className="user__image" alt="user" src="https://front.travpromobile.com/614/jj.jpg" />
            <div className="user">JJ Villani</div>
            <div className="sub">VP, Sales & Business Development at TravPRO Mobile
            </div>
            <hr />
            <div className="socials">
              <span>Connect with me:</span>
              <div className="social__items">
                <a href="mailto:jvillani@travpromobile.com">
                  <FontAwesomeIcon icon={['fas', 'envelope']} />
                </a>
                <a href="jvillani@travpromobile.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={['fab', 'linkedin']} />
                </a>
              </div>
            </div>
          </div>

        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}


SessionItemView3.propTypes = {
  match: PropTypes.shape().isRequired,
};
